import { getSdk } from '__generated__/api';
import { GraphQLClient } from 'graphql-request';
import { Logger, SystemEvent, SystemEventLevel } from 'bernie-logger';

export const getBexApiSdk = (
  headers: HeadersInit,
  url = '/graphql',
  appName?: string,
  region?: string,
  logger?: Logger
) => {
  logger?.logEvent(
    new SystemEvent(SystemEventLevel.INFO, 'BEX_API_SDK_BUILD'),
    `Building SDK with these headers: ${JSON.stringify(headers)}`
  );
  const CLIENT_INFO = `${appName || 'flights-shopping-pwa'},latest,${region || 'external'}`;
  const sdkHeaders = { ...headers, 'Client-Info': CLIENT_INFO };
  const options: RequestInit = {
    headers: new Headers(sdkHeaders),
    credentials: 'same-origin',
    cache: 'no-cache'
  };
  const client = new GraphQLClient(url, options);
  logger?.logEvent(
    new SystemEvent(SystemEventLevel.INFO, 'BEX_API_SDK_BUILD'),
    `Building SDK with these options: ${JSON.stringify(Object.fromEntries(options.headers as Headers))}`
  );

  return getSdk(client);
};
